import { gql } from "@apollo/client";
import type { MockedResponse } from "@apollo/client/testing";
import { oneSeriesTrendProperties } from "./TrendsUtils";

export const GET_TREND = gql`
  query getTrend(
    $timescale: TimeScales
    $selection: [String]
    $group_by: [String]
    $aggregate_functions: [AggregateFunctions]
    $round_functions: [RoundFunctions]
    $filters_config: FiltersConfigInput
    $snapshots_filters_config: FiltersConfigInput
    $widgetKey: WidgetDefinitionKey
  ) {
    trends(
      timescale: $timescale
      selection: $selection
      group_by: $group_by
      aggregate_functions: $aggregate_functions
      round_functions: $round_functions
      filters_config: $filters_config
      snapshots_filters_config: $snapshots_filters_config
      widget_definition_key: $widgetKey
    )
  }
`;

export interface TrendFiltersConfig {
  filtersjson?: unknown;
  scopesjson?: unknown;
  scopesid?: string;
  filters_fields_to_exclude?: string[];
  filters_fields_to_include?: string[];
}

export interface TrendParameters {
  selection?: string[];
  timescale?: string;
  group_by?: string[];
  filters_config?: TrendFiltersConfig;
  snapshots_filters_config?: TrendFiltersConfig;
  aggregate_functions?: string[];
  round_functions?: string[];
  widgetKey?: string;
}

export interface TrendVariables {
  parameters?: TrendParameters;
}

export interface GenerateGetTrendMockOptions {
  variables?: TrendVariables | null;
  result?: Record<string, unknown> | null;
  error?: Error | null;
}

export const generateGetTrendMock = ({
  variables = null,
  result = null,
  error = null,
}: GenerateGetTrendMockOptions): MockedResponse => {
  let parameters = {
    selection:
      variables?.parameters?.selection ||
      oneSeriesTrendProperties.newFindingsByDiscoveryDate.queryNameVariable,
    timescale: variables?.parameters?.timescale || "WEEK",
    filters_config: variables?.parameters?.filters_config,
    aggregate_functions: variables?.parameters?.aggregate_functions || ["SUM"],
    round_functions: variables?.parameters?.round_functions || ["ROUND"],
  };

  let getTrendMock: MockedResponse = {
    request: {
      query: GET_TREND,
      variables: {
        ...variables?.parameters,
        ...parameters,
      },
    },
  };

  if (error) {
    return {
      ...getTrendMock,
      error: error,
    };
  }

  if (result) {
    return {
      ...getTrendMock,
      result: { data: result },
    };
  }

  return {
    ...getTrendMock,
    result: { data: { trends: JSON.stringify([]) } },
  };
};
